<template>
  <div class="works-board">
    <div class="board-container">
      <div class="board-toolbar">
        <el-date-picker
          v-model="baseRequest.selectDate"
          type="daterange"
          range-separator="至"
          size="mini"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectBoardDate"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <div class="toolbar-btns">
          <el-button size="mini" @click="getBoardPerformanceByLastDay">昨日查看</el-button>
          <el-button size="mini" @click="getBoardPerformanceByDay">按日查看</el-button>
          <el-button size="mini" @click="getBoardPerformanceBy7Day">近七日查看</el-button>
          <el-button size="mini" @click="getBoardPerformanceByMonth">当月查看</el-button>
          <el-button size="mini" @click="getBoardPerformanceByYear">当年查看</el-button>
          <el-button size="mini" class="warn-btn" @click="getNoOrderShop">未报账店面查看</el-button>
        </div>
      </div>
      <div class="kpi-row">
        <div class="kpi-card kpi--orange">
          <div class="kpi-icon"><i class="iconfont icon-pinpaixiaoshou"></i></div>
          <div class="kpi-body">
            <div class="kpi-value">销售额：{{boardPerformance.performance}}</div>
            <div class="kpi-sub">上期金额：{{boardPerformance.lastPerformance}}</div>
          </div>
        </div>
        <div class="kpi-card kpi--plum">
          <div class="kpi-icon"><i class="iconfont icon-yonghu"></i></div>
          <div class="kpi-body">
            <div class="kpi-value">消费人次：{{boardPerformance.peoples}}</div>
            <div class="kpi-sub">上期人次：{{boardPerformance.lastPeoples}}</div>
          </div>
        </div>
        <div class="kpi-card kpi--green">
          <div class="kpi-icon"><i class="iconfont icon-baobiao"></i></div>
          <div class="kpi-body">
            <div class="kpi-value">平均业绩：{{boardPerformance.avgPerformance}}</div>
            <div class="kpi-sub">上期业绩：{{boardPerformance.lastAvgPerformance}}</div>
          </div>
        </div>
        <div class="kpi-card kpi--purple">
          <div class="kpi-icon"><i class="iconfont icon-dianpu"></i></div>
          <div class="kpi-body">
            <div class="kpi-value">有效门店：{{boardPerformance.invalidShop}}</div>
            <div class="kpi-sub">上期门店：{{boardPerformance.lastInvalidShop}}</div>
          </div>
        </div>
      </div>
      <el-card class="panel-card metric-panel">
        <div class="metric-grid">
          <div class="metric-card metric--teal">
            <div class="metric-icon"><i class="iconfont icon-31quanbushangpin"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardCfk.productPerformance}}</div>
              <div class="metric-label">商品销售金额</div>
            </div>
          </div>
          <div class="metric-card metric--red">
            <div class="metric-icon"><i class="iconfont icon-fuwu_o"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardCfk.servicePerformance}}</div>
              <div class="metric-label">服务销售金额</div>
            </div>
          </div>
          <div class="metric-card metric--orange">
            <div class="metric-icon"><i class="iconfont icon-kangfuke"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardCfk.recoveryPerformance}}</div>
              <div class="metric-label">康复销售金额</div>
            </div>
          </div>
          <div class="metric-card metric--green">
            <div class="metric-icon"><i class="iconfont icon-chongzhi0101"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardCtq.memberRecharge}}</div>
              <div class="metric-label">会员充值金额</div>
            </div>
          </div>
          <div class="metric-card metric--purple">
            <div class="metric-icon"><i class="iconfont icon-tuifeibaozhang1"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardCtq.memberReturn}}</div>
              <div class="metric-label">会员退费金额</div>
            </div>
          </div>
          <div class="metric-card metric--blue">
            <div class="metric-icon"><i class="iconfont icon-tuifeibaozhang1"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardCtq.refundOrder}}</div>
              <div class="metric-label">消费单退费金额</div>
            </div>
          </div>
          <div class="metric-card metric--cyan">
            <div class="metric-icon"><i class="iconfont icon-guazhangguanli"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardCtq.debt}}</div>
              <div class="metric-label">累计欠款单</div>
            </div>
          </div>
          <div class="metric-card metric--blue">
            <div class="metric-icon"><i class="iconfont icon-cangkukucun"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardKyz.storeOut}}</div>
              <div class="metric-label">库存不足</div>
            </div>
          </div>
          <div class="metric-card metric--purple">
            <div class="metric-icon"><i class="iconfont icon-renyuan1"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardKyz.reserveNumber}}</div>
              <div class="metric-label">预约人数</div>
            </div>
          </div>
          <div class="metric-card metric--gold">
            <div class="metric-icon"><i class="iconfont icon-renyuan1"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardWxf.oneToThreeMonthNumber}}</div>
              <div class="metric-label">1-3月未消费的顾客</div>
            </div>
          </div>
          <div class="metric-card metric--orange">
            <div class="metric-icon"><i class="iconfont icon-renyuan1"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardWxf.fourToSixMonthNumber}}</div>
              <div class="metric-label">4-6月未消费的顾客</div>
            </div>
          </div>
          <div class="metric-card metric--red">
            <div class="metric-icon"><i class="iconfont icon-renyuan1"></i></div>
            <div class="metric-text">
              <div class="metric-value">{{boardKyz.newMemberNumber}}</div>
              <div class="metric-label">新增会员人数</div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="panel-card">
        <div class="chart-row chart-row--half">
          <div id="yjLineECharts" class="chart-box"></div>
          <div id="yjZbECharts" class="chart-box"></div>
        </div>
      </el-card>
      <el-card class="panel-card">
        <div class="chart-row chart-row--rank">
          <!-- 业绩排行 -->
          <div id="yjPhECharts" class="chart-box rank-box"></div>
          <!-- 工资排行 -->
          <div id="gzPhECharts" class="chart-box rank-box"></div>
          <!-- 客单价排行 -->
          <div id="kdjPhECharts" class="chart-box rank-box"></div>
          <!-- 明星产品 -->
          <div id="mxCpECharts" class="chart-box rank-box"></div>
          <!-- 明星服务 -->
          <div id="mxFwECharts" class="chart-box rank-box"></div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      shopId:'',
      orgLevel:'',
      boardPerformance:'',
      boardCfk:'',
      boardCtq:'',
      boardKyz:'',
      boardWxf:'',
      yearData:[],
      lineData:[],
      jxData:[],
      topYjName:[],
      topYjValue:[],
      topGzName:[],
      topGzValue:[],
      topKdjName:[],
      topKdjValue:[],
      starProductName:[],
      starProductValue:[],
      starServiceName:[],
      starServiceValue:[],
      baseRequest:{
        selectDate:'',
        shopId:'',
        orgLevel:'',
        startDate:'',
        endDate:''
      }

    }
  },
  methods:{
    selectBoardDate(){
      if (this.baseRequest.selectDate === null){
        this.baseRequest.startDate = '';
        this.baseRequest.endDate = '';
      } else {
        this.baseRequest.startDate = this.baseRequest.selectDate[0];
        this.baseRequest.endDate = this.baseRequest.selectDate[1];
      }
    },
    getBoardLineData(){
      this.$http.get(`/board/line/${this.shopId}/${this.orgLevel}`).then(lineRes =>{
        this.lineData = lineRes.data.data;
        this.yearData[0] = lineRes.data.data[0].name;
        this.yearData[1] = lineRes.data.data[1].name;
        this.drawYjLineECHarts();
      });
    },
    //获取系统当前日期前7天日期
    getLast7Date(value) {
      let date = new Date(new Date().getTime());
      let date2 = new Date(date);
      date2.setDate(date.getDate() - value);
      let year = date2.getFullYear();
      let month = date2.getMonth() + 1;
      let day = date2.getDate();
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return year + '-' + month + '-' + day;
    },
    getBoardPerformanceByLastDay(){
      this.baseRequest.startDate = this.getLast7Date(1);
      this.baseRequest.endDate = this.getLast7Date(1);
      this.$http.post(`/board/day/getPerformance`, this.baseRequest).then(res => {
        this.boardPerformance = res.data.data;
      });

      this.$http.post(`/board/day/cfk`, this.baseRequest).then(cfkRes => {
        this.boardCfk = cfkRes.data.data;
      });

      this.$http.post(`/board/day/ctq`, this.baseRequest).then(ctqRes =>{
        this.boardCtq = ctqRes.data.data;
      });

      this.$http.post(`/board/day/kyz`, this.baseRequest).then(kyzRes =>{
        this.boardKyz = kyzRes.data.data;
      });

      this.$http.get(`/board/wxf/${this.shopId}/${this.orgLevel}`).then(wxfRes =>{
        this.boardWxf = wxfRes.data.data;
      });

      this.$http.post(`/board/day/jxt`, this.baseRequest).then(jxRes =>{
        this.jxData = jxRes.data.data;
        this.drawYjZbECHarts();
      });

      this.$http.post(`/board/day/jxt`, this.baseRequest).then(jxRes =>{
        this.jxData = jxRes.data.data;
        this.drawTop10Yj();
      });

      this.$http.post(`/board/day/topTen`, this.baseRequest).then(topYjRes =>{
        let topYj = topYjRes.data.data;
        for (let i = 0; i<topYj.length;i++){
          this.topYjName[i] = topYj[i].name;
          this.topYjValue[i] = topYj[i].value;
        }
        this.drawTop10Yj();
      });

      this.$http.post(`/board/day/topTen/salary`, this.baseRequest).then(topGzRes =>{
        let topGz = topGzRes.data.data;
        for (let i = 0; i<topGz.length;i++){
          this.topGzName[i] = topGz[i].name;
          this.topGzValue[i] = topGz[i].value;
        }
        this.drawTop10Gz();
      });
      //客单价
      this.$http.post(`/board/day/topTen/kdj`, this.baseRequest).then(topKdjRes =>{
        let topKdj = topKdjRes.data.data;
        for (let i = 0; i < topKdj.length;i++){
          this.topKdjName[i] = topKdj[i].name;
          this.topKdjValue[i] = topKdj[i].value;
        }
        this.drawTop10Kdj();
      });
      //明星产品
      this.$http.post(`/board/day/star/product`, this.baseRequest).then(topKdjRes =>{
        let topKdj = topKdjRes.data.data;
        for (let i = 0; i < topKdj.length;i++){
          this.topKdjName[i] = topKdj[i].name;
          this.topKdjValue[i] = topKdj[i].value;
        }
        this.drawStarProduct();
      });
      //明星服务
      this.$http.post(`/board/day/star/service`, this.baseRequest).then(topKdjRes =>{
        let data = topKdjRes.data.data;
        for (let i = 0; i < data.length;i++){
          this.starServiceName[i] = data[i].name;
          this.starServiceValue[i] = data[i].value;
        }
        this.drawStarService();
      });
    },
    getBoardPerformanceByDay(){
      if (this.baseRequest.selectDate === null || this.baseRequest.selectDate === ''){
        this.baseRequest.startDate = this.getLast7Date(0);
        this.baseRequest.endDate = this.getLast7Date(0);
      }
      // this.baseRequest.startDate = this.getLast7Date(0);
      // this.baseRequest.endDate = this.getLast7Date(0);
      this.$http.post(`/board/day/getPerformance`, this.baseRequest).then(res => {
        this.boardPerformance = res.data.data;
      });

      this.$http.post(`/board/day/cfk`, this.baseRequest).then(cfkRes => {
        this.boardCfk = cfkRes.data.data;
      });

      this.$http.post(`/board/day/ctq`, this.baseRequest).then(ctqRes =>{
        this.boardCtq = ctqRes.data.data;
      });

      this.$http.post(`/board/day/kyz`, this.baseRequest).then(kyzRes =>{
        this.boardKyz = kyzRes.data.data;
      });

      this.$http.get(`/board/wxf/${this.shopId}/${this.orgLevel}`).then(wxfRes =>{
        this.boardWxf = wxfRes.data.data;
      });

      this.$http.post(`/board/day/jxt`, this.baseRequest).then(jxRes =>{
        this.jxData = jxRes.data.data;
        this.drawYjZbECHarts();
      });

      this.$http.post(`/board/day/jxt`, this.baseRequest).then(jxRes =>{
        this.jxData = jxRes.data.data;
        this.drawTop10Yj();
      });

      this.$http.post(`/board/day/topTen`, this.baseRequest).then(topYjRes =>{
        let topYj = topYjRes.data.data;
        for (let i = 0; i<topYj.length;i++){
          this.topYjName[i] = topYj[i].name;
          this.topYjValue[i] = topYj[i].value;
        }
        this.drawTop10Yj();
      });

      this.$http.post(`/board/day/topTen/salary`, this.baseRequest).then(topGzRes =>{
        let topGz = topGzRes.data.data;
        for (let i = 0; i<topGz.length;i++){
          this.topGzName[i] = topGz[i].name;
          this.topGzValue[i] = topGz[i].value;
        }
        this.drawTop10Gz();
      });
      //客单价
      this.$http.post(`/board/day/topTen/kdj`, this.baseRequest).then(topKdjRes =>{
        let topKdj = topKdjRes.data.data;
        for (let i = 0; i < topKdj.length;i++){
          this.topKdjName[i] = topKdj[i].name;
          this.topKdjValue[i] = topKdj[i].value;
        }
        this.drawTop10Kdj();
      });
      //明星产品
      this.$http.post(`/board/day/star/product`, this.baseRequest).then(topKdjRes =>{
        let topKdj = topKdjRes.data.data;
        for (let i = 0; i < topKdj.length;i++){
          this.topKdjName[i] = topKdj[i].name;
          this.topKdjValue[i] = topKdj[i].value;
        }
        this.drawStarProduct();
      });
      //明星服务
      this.$http.post(`/board/day/star/service`, this.baseRequest).then(topKdjRes =>{
        let data = topKdjRes.data.data;
        for (let i = 0; i < data.length;i++){
          this.starServiceName[i] = data[i].name;
          this.starServiceValue[i] = data[i].value;
        }
        this.drawStarService();
      });

    },
    getBoardPerformanceBy7Day(){
      this.baseRequest.startDate = this.getLast7Date(7);
      this.baseRequest.endDate = this.getLast7Date(0);
      this.$http.post(`/board/day/getPerformance`, this.baseRequest).then(res => {
        this.boardPerformance = res.data.data;
      });

      this.$http.post(`/board/day/cfk`, this.baseRequest).then(cfkRes => {
        this.boardCfk = cfkRes.data.data;
      });

      this.$http.post(`/board/day/ctq`, this.baseRequest).then(ctqRes =>{
        this.boardCtq = ctqRes.data.data;
      });

      this.$http.post(`/board/day/kyz`, this.baseRequest).then(kyzRes =>{
        this.boardKyz = kyzRes.data.data;
      });

      this.$http.get(`/board/wxf/${this.shopId}/${this.orgLevel}`).then(wxfRes =>{
        this.boardWxf = wxfRes.data.data;
      });

      this.$http.post(`/board/day/jxt`, this.baseRequest).then(jxRes =>{
        this.jxData = jxRes.data.data;
        this.drawYjZbECHarts();
      });

      this.$http.post(`/board/day/jxt`, this.baseRequest).then(jxRes =>{
        this.jxData = jxRes.data.data;
        this.drawTop10Yj();
      });

      this.$http.post(`/board/day/topTen`, this.baseRequest).then(topYjRes =>{
        let topYj = topYjRes.data.data;
        for (let i = 0; i<topYj.length;i++){
          this.topYjName[i] = topYj[i].name;
          this.topYjValue[i] = topYj[i].value;
        }
        this.drawTop10Yj();
      });

      this.$http.post(`/board/day/topTen/salary`, this.baseRequest).then(topGzRes =>{
        let topGz = topGzRes.data.data;
        for (let i = 0; i<topGz.length;i++){
          this.topGzName[i] = topGz[i].name;
          this.topGzValue[i] = topGz[i].value;
        }
        this.drawTop10Gz();
      });
      //客单价
      this.$http.post(`/board/day/topTen/kdj`, this.baseRequest).then(topKdjRes =>{
        let topKdj = topKdjRes.data.data;
        for (let i = 0; i < topKdj.length;i++){
          this.topKdjName[i] = topKdj[i].name;
          this.topKdjValue[i] = topKdj[i].value;
        }
        this.drawTop10Kdj();
      });
      //明星产品
      this.$http.post(`/board/day/star/product`, this.baseRequest).then(topKdjRes =>{
        let topKdj = topKdjRes.data.data;
        for (let i = 0; i < topKdj.length;i++){
          this.topKdjName[i] = topKdj[i].name;
          this.topKdjValue[i] = topKdj[i].value;
        }
        this.drawStarProduct();
      });
      //明星服务
      this.$http.post(`/board/day/star/service`, this.baseRequest).then(topKdjRes =>{
        let data = topKdjRes.data.data;
        for (let i = 0; i < data.length;i++){
          this.starServiceName[i] = data[i].name;
          this.starServiceValue[i] = data[i].value;
        }
        this.drawStarService();
      });

    },
    getBoardPerformanceByMonth(){
      this.$http.get(`/board/month/getPerformance/${this.shopId}/${this.orgLevel}`).then(res => {
        this.boardPerformance = res.data.data;
      });

      this.$http.get(`/board/month/cfk/${this.shopId}/${this.orgLevel}`).then(cfkRes => {
        this.boardCfk = cfkRes.data.data;
      });

      this.$http.get(`/board/month/ctq/${this.shopId}/${this.orgLevel}`).then(ctqRes =>{
        this.boardCtq = ctqRes.data.data;
      });

      this.$http.get(`/board/month/kyz/${this.shopId}/${this.orgLevel}`).then(kyzRes =>{
        this.boardKyz = kyzRes.data.data;
      });

      this.$http.get(`/board/wxf/${this.shopId}/${this.orgLevel}`).then(wxfRes =>{
        this.boardWxf = wxfRes.data.data;
      });

      this.$http.get(`/board/month/jxt/${this.shopId}/${this.orgLevel}`).then(jxRes =>{
        this.jxData = jxRes.data.data;
        this.drawYjZbECHarts();
      });

      this.$http.get(`/board/month/topTen/${this.shopId}/${this.orgLevel}`).then(topYjRes =>{
        let topYj = topYjRes.data.data;
        for (let i = 0; i<topYj.length;i++){
          this.topYjName[i] = topYj[i].name;
          this.topYjValue[i] = topYj[i].value;
        }
        this.drawTop10Yj();
      });

      this.$http.get(`/board/month/topTen/salary/${this.shopId}/${this.orgLevel}`).then(topGzRes =>{
        let topGz = topGzRes.data.data;
        for (let i = 0; i<topGz.length;i++){
          this.topGzName[i] = topGz[i].name;
          this.topGzValue[i] = topGz[i].value;
        }
        this.drawTop10Gz();
      });

      this.$http.get(`/board/month/topTen/kdj/${this.shopId}/${this.orgLevel}`).then(topKdjRes =>{
        let topKdj = topKdjRes.data.data;
        for (let i = 0; i < topKdj.length;i++){
          this.topKdjName[i] = topKdj[i].name;
          this.topKdjValue[i] = topKdj[i].value;
        }
        this.drawTop10Kdj();
      });

      this.$http.get(`/board/month/star/product/${this.shopId}/${this.orgLevel}`).then(topKdjRes =>{
        let topKdj = topKdjRes.data.data;
        for (let i = 0; i < topKdj.length;i++){
          this.topKdjName[i] = topKdj[i].name;
          this.topKdjValue[i] = topKdj[i].value;
        }
        this.drawStarProduct();
      });

      this.$http.get(`/board/month/star/service/${this.shopId}/${this.orgLevel}`).then(topKdjRes =>{
        let data = topKdjRes.data.data;
        for (let i = 0; i < data.length;i++){
          this.starServiceName[i] = data[i].name;
          this.starServiceValue[i] = data[i].value;
        }
        this.drawStarService();
      });
    },
    getBoardPerformanceByYear(){
      this.$http.get(`/board/year/getPerformance/${this.shopId}/${this.orgLevel}`).then(res =>{
        this.boardPerformance = res.data.data;
      });

      this.$http.get(`/board/year/cfk/${this.shopId}/${this.orgLevel}`).then(cfkRes => {
        this.boardCfk = cfkRes.data.data;
      });

      this.$http.get(`/board/year/ctq/${this.shopId}/${this.orgLevel}`).then(ctqRes => {
        this.boardCtq = ctqRes.data.data;
      });

      this.$http.get(`/board/year/kyz/${this.shopId}/${this.orgLevel}`).then(kyzRes =>{
        this.boardKyz = kyzRes.data.data;
      });

      this.$http.get(`/board/wxf/${this.shopId}/${this.orgLevel}`).then(wxfRes =>{
        this.boardWxf = wxfRes.data.data;
      });

      this.$http.get(`/board/year/jxt/${this.shopId}/${this.orgLevel}`).then(jxRes =>{
        this.jxData = jxRes.data.data;
        this.drawYjZbECHarts();
      });

      this.$http.get(`/board/year/topTen/${this.shopId}/${this.orgLevel}`).then(topYjRes =>{
        let topYj = topYjRes.data.data;
        for (let i = 0; i<topYj.length;i++){
          this.topYjName[i] = topYj[i].name;
          this.topYjValue[i] = topYj[i].value;
        }
        this.drawTop10Yj();
      });

      this.$http.get(`/board/year/topTen/salary/${this.shopId}/${this.orgLevel}`).then(topGzRes =>{
        let topGz = topGzRes.data.data;
        for (let i = 0; i<topGz.length;i++){
          this.topGzName[i] = topGz[i].name;
          this.topGzValue[i] = topGz[i].value;
        }
        this.drawTop10Gz();
      });

      this.$http.get(`/board/year/topTen/kdj/${this.shopId}/${this.orgLevel}`).then(topKdjRes =>{
        let topKdj = topKdjRes.data.data;
        for (let i = 0; i < topKdj.length;i++){
          this.topKdjName[i] = topKdj[i].name;
          this.topKdjValue[i] = topKdj[i].value;
        }
        this.drawTop10Kdj();
      });

      this.$http.get(`/board/year/star/product/${this.shopId}/${this.orgLevel}`).then(topKdjRes =>{
        let topKdj = topKdjRes.data.data;
        for (let i = 0; i < topKdj.length;i++){
          this.topKdjName[i] = topKdj[i].name;
          this.topKdjValue[i] = topKdj[i].value;
        }
        this.drawStarProduct();
      });

      this.$http.get(`/board/year/star/service/${this.shopId}/${this.orgLevel}`).then(topKdjRes =>{
        let data = topKdjRes.data.data;
        for (let i = 0; i < data.length;i++){
          this.starServiceName[i] = data[i].name;
          this.starServiceValue[i] = data[i].value;
        }
        this.drawStarService();
      });
    },
    drawYjLineECHarts(){
      const dom = document.getElementById("yjLineECharts");
      if (!dom) return;
      const chart = this.$echarts.getInstanceByDom(dom) || this.$echarts.init(dom);
      // 配色与排行图保持一致：蓝 / 橙 / 绿
      const palette = [
        { from: '#9fd4ff', to: '#1f6bff', area: 'rgba(31, 107, 255, 0.20)' },
        { from: '#ffd28e', to: '#ff7a00', area: 'rgba(255, 122, 0, 0.18)' },
        { from: '#5be79a', to: '#07b864', area: 'rgba(7, 184, 100, 0.18)' }
      ];
      const lineSeries = [];
      const flowSeries = [];
      this.lineData.forEach((item, idx) => {
        const color = palette[idx % palette.length];
        lineSeries.push({
          name: item.name,
          type: 'line',
          smooth: 0.3,
          symbol: 'circle',
          symbolSize: 7,
          itemStyle: {
            color: color.to,
            borderColor: '#fff',
            borderWidth: 2
          },
          lineStyle: {
            width: 3,
            color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
              { offset: 0, color: color.from },
              { offset: 1, color: color.to }
            ]),
            shadowColor: color.area,
            shadowBlur: 12,
            shadowOffsetY: 8
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: color.area },
              { offset: 1, color: 'rgba(255, 255, 255, 0)' }
            ])
          },
          emphasis: { focus: 'series' },
          animationDuration: 1400,
          animationEasing: 'cubicOut',
          animationDelay: idx * 200,
          data: item.data
        });
        // 流光层：发光点沿折线路径循环流动
        flowSeries.push({
          name: item.name,
          type: 'lines',
          coordinateSystem: 'cartesian2d',
          polyline: true,
          silent: true,
          z: 10,
          effect: {
            show: true,
            period: 6,
            delay: idx * 2500,
            trailLength: 0.5,
            symbol: 'circle',
            symbolSize: 5,
            color: '#fff'
          },
          lineStyle: { width: 0, opacity: 0 },
          data: [{ coords: (item.data || []).map((v, i) => [i, v]) }]
        });
      });
      chart.setOption({
        title: {
          text: '同期业绩数据对比',
          left: 12,
          top: 10,
          textStyle: {
            fontSize: 14,
            fontWeight: 600,
            color: '#1f2d3d'
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(31, 45, 61, 0.9)',
          borderWidth: 0,
          textStyle: { color: '#fff', fontSize: 12 },
          axisPointer: {
            type: 'line',
            lineStyle: { color: 'rgba(31, 45, 61, 0.25)', type: 'dashed' }
          },
          formatter(params) {
            // 过滤掉流光层，只展示真实数据线
            const list = params.filter(p => p.seriesType === 'line');
            if (!list.length) return '';
            let html = list[0].axisValue + '<br/>';
            list.forEach(p => {
              html += p.marker + ' ' + p.seriesName + '：' + p.value + '<br/>';
            });
            return html;
          }
        },
        legend: {
          data: this.yearData,
          right: 56,
          top: 14,
          icon: 'roundRect',
          itemWidth: 14,
          itemHeight: 6,
          textStyle: { color: '#5a6a85', fontSize: 12 }
        },
        toolbox: {
          right: 16,
          top: 10,
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          top: 46,
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisLine: { lineStyle: { color: '#dfe5ef' } },
          axisTick: { show: false },
          axisLabel: { color: '#7a879c', fontSize: 12 }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#7a879c', fontSize: 12 },
          splitLine: { lineStyle: { color: '#edf1f7', type: 'dashed' } }
        },
        series: lineSeries.concat(flowSeries)
      });
    },
    drawYjZbECHarts(){
      const dom = document.getElementById("yjZbECharts");
      if (!dom) return;
      const chart = this.$echarts.getInstanceByDom(dom) || this.$echarts.init(dom);
      // 与看板一致的竖向渐变配色
      const treemapColors = [
        ['#ffb35c', '#ff7a00'],
        ['#7cc7ff', '#1f6bff'],
        ['#e3a6ff', '#8a3ffc'],
        ['#5be79a', '#07b864'],
        ['#5eead4', '#00b2a0'],
        ['#ff9a8b', '#ff5333'],
        ['#ffd76e', '#e0a800'],
        ['#6ee7ff', '#00b8d9']
      ].map(pair => new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: pair[0] },
        { offset: 1, color: pair[1] }
      ]));
      const total = (this.jxData || []).reduce((sum, d) => sum + (Number(d.value) || 0), 0);
      chart.setOption({
        title: {
          text: '业绩占比图',
          left: 12,
          top: 10,
          textStyle: {
            fontSize: 14,
            fontWeight: 600,
            color: '#1f2d3d'
          }
        },
        tooltip: {
          backgroundColor: 'rgba(31, 45, 61, 0.9)',
          borderWidth: 0,
          textStyle: { color: '#fff', fontSize: 12 },
          formatter(p) {
            const percent = total ? ((p.value / total) * 100).toFixed(1) : '0.0';
            return p.marker + ' ' + p.name + '：' + p.value + '（' + percent + '%）';
          }
        },
        series: [
          {
            type: 'treemap',
            top: 46,
            left: 12,
            right: 12,
            bottom: 12,
            roam: false,
            nodeClick: false,
            breadcrumb: { show: false },
            color: treemapColors,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 2,
              gapWidth: 2,
              borderRadius: 6
            },
            label: {
              show: true,
              position: 'inside',
              color: '#fff',
              fontSize: 12,
              fontWeight: 600,
              lineHeight: 18,
              overflow: 'truncate',
              textBorderColor: 'rgba(0, 0, 0, 0.25)',
              textBorderWidth: 2,
              formatter(p) {
                if (p.value > 0) {
                  const percent = total ? ((p.value / total) * 100).toFixed(1) : '0.0';
                  return p.name + '\n' + p.value + '（' + percent + '%）';
                }
                return '';
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 14,
                shadowColor: 'rgba(31, 45, 61, 0.35)'
              }
            },
            animationDuration: 800,
            animationEasing: 'cubicOut',
            data: this.jxData
          }
        ]
      });
    },
    // 排行柱状图通用渲染：细柱 + 渐变 + 底色轨道 + 流光斜纹
    renderRankBar(id, title, names, values, fromColor, toColor) {
      const dom = document.getElementById(id);
      if (!dom) return;
      const chart = this.$echarts.getInstanceByDom(dom) || this.$echarts.init(dom);
      chart.setOption({
        title: {
          text: title,
          left: 12,
          top: 10,
          textStyle: {
            fontSize: 14,
            fontWeight: 600,
            color: '#1f2d3d'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          top: 40,
          left: '3%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: { show: false },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'category',
          data: names,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: '#5a6a85',
            fontSize: 12
          }
        },
        series: [
          {
            type: 'bar',
            barWidth: 8,
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(31, 45, 61, 0.07)',
              borderRadius: 4
            },
            itemStyle: {
              borderRadius: 4,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: fromColor },
                { offset: 1, color: toColor }
              ]),
              shadowBlur: 10,
              shadowColor: toColor
            },
            z: 2,
            data: values
          },
          {
            // 流光斜纹（沿柱体循环流动）
            type: 'pictorialBar',
            symbol: 'path://M0,0 L4,0 L8,16 L4,16 Z',
            symbolSize: [7, 8],
            symbolRepeat: true,
            symbolMargin: 13,
            symbolClip: true,
            symbolOffset: [0, 0],
            itemStyle: {
              color: 'rgba(255, 255, 255, 0.9)',
              shadowBlur: 6,
              shadowColor: 'rgba(255, 255, 255, 0.9)'
            },
            animationDurationUpdate: 0,
            z: 3,
            data: values
          }
        ]
      });
      this.registerRankFlow(id);
    },
    // 驱动流光斜纹循环位移（周期 = symbolSize宽7 + symbolMargin13 = 20px）
    registerRankFlow(id) {
      if (!this.rankFlowIds) {
        this.rankFlowIds = [];
      }
      if (this.rankFlowIds.indexOf(id) === -1) {
        this.rankFlowIds.push(id);
      }
      if (this.rankFlowTimer) return;
      let offset = 0;
      this.rankFlowTimer = setInterval(() => {
        offset = (offset + 1) % 20;
        this.rankFlowIds.forEach(cid => {
          const flowDom = document.getElementById(cid);
          if (!flowDom) return;
          const flowChart = this.$echarts.getInstanceByDom(flowDom);
          if (flowChart) {
            flowChart.setOption({ series: [{}, { symbolOffset: [offset, 0] }] });
          }
        });
      }, 50);
    },
    drawTop10Yj(){
      this.renderRankBar('yjPhECharts', '业绩前十名', this.topYjName, this.topYjValue, '#ffd28e', '#ff7a00');
    },
    drawTop10Gz(){
      this.renderRankBar('gzPhECharts', '工资前十名', this.topGzName, this.topGzValue, '#7cc7ff', '#1f6bff');
    },
    drawTop10Kdj(){
      this.renderRankBar('kdjPhECharts', '最高客单价', this.topKdjName, this.topKdjValue, '#e3a6ff', '#8a3ffc');
    },
    drawStarProduct(){
      this.renderRankBar('mxCpECharts', '明星产品', this.topKdjName, this.topKdjValue, '#5be79a', '#07b864');
    },
    drawStarService(){
      this.renderRankBar('mxFwECharts', '明星服务', this.starServiceName, this.starServiceValue, '#5eead4', '#00b2a0');
    },
    getNoOrderShop(){
      this.$router.push('/no/order/shop')
    }
  },
  beforeDestroy() {
    if (this.rankFlowTimer) {
      clearInterval(this.rankFlowTimer);
      this.rankFlowTimer = null;
    }
  },
  created() {
    this.shopId = window.sessionStorage.getItem('currentOrgId');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.baseRequest.shopId = this.shopId;
    this.baseRequest.orgLevel = this.orgLevel;
    this.getBoardPerformanceByDay();
    this.getBoardLineData();
  }
}
</script>

<style lang="less" scoped>
  /* ===== 页面底色与容器 ===== */
  .works-board {
    padding: 14px 16px 20px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #eef2f8 0%, #f5f7fb 100%);
  }

  /* ===== 顶部工具栏 ===== */
  .board-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 16px;
    margin-bottom: 16px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(31, 45, 61, 0.06);

    .toolbar-btns {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    ::v-deep .el-button--mini {
      padding: 7px 14px;
      border-radius: 6px;
    }

    .warn-btn {
      color: #f56c6c;
      background: #fef0f0;
      border-color: #f9b4b4;

      &:hover,
      &:focus {
        color: #fff;
        background: #f56c6c;
        border-color: #f56c6c;
      }
    }
  }

  /* ===== 核心 KPI 卡片 ===== */
  .kpi-row {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    margin-bottom: 16px;
  }

  .kpi-card {
    position: relative;
    flex: 1 1 0;
    min-width: 0;
    height: 96px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    border-radius: 14px;
    color: #fff;
    overflow: hidden;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    animation: kpiFadeIn 0.55s ease both;

    &:nth-child(1) { animation-delay: 0.05s; }
    &:nth-child(2) { animation-delay: 0.12s; }
    &:nth-child(3) { animation-delay: 0.19s; }
    &:nth-child(4) { animation-delay: 0.26s; }

    /* 装饰圆斑 */
    &::before {
      content: '';
      position: absolute;
      right: -34px;
      top: -34px;
      width: 118px;
      height: 118px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.08);
    }

    &::after {
      content: '';
      position: absolute;
      right: 28px;
      bottom: -54px;
      width: 90px;
      height: 90px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.06);
    }

    &:hover {
      transform: translateY(-4px);
    }
  }

  .kpi-icon {
    position: relative;
    z-index: 1;
    flex: none;
    width: 54px;
    height: 54px;
    margin-right: 16px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.18);

    .iconfont {
      font-size: 30px;
      color: #fff;
    }
  }

  .kpi-body {
    position: relative;
    z-index: 1;
    min-width: 0;
  }

  .kpi-value {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  }

  .kpi-sub {
    margin-top: 4px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.85);
    white-space: nowrap;
  }

  .kpi--orange {
    background: linear-gradient(135deg, #f7994d 0%, #d65a08 100%);
    box-shadow: 0 10px 24px -10px rgba(214, 90, 8, 0.55);

    &:hover { box-shadow: 0 16px 32px -12px rgba(214, 90, 8, 0.7); }
  }

  .kpi--plum {
    background: linear-gradient(135deg, #8c4a76 0%, #470e3c 100%);
    box-shadow: 0 10px 24px -10px rgba(71, 14, 60, 0.55);

    &:hover { box-shadow: 0 16px 32px -12px rgba(71, 14, 60, 0.7); }
  }

  .kpi--green {
    background: linear-gradient(135deg, #35d277 0%, #0d9f47 100%);
    box-shadow: 0 10px 24px -10px rgba(19, 169, 78, 0.5);

    &:hover { box-shadow: 0 16px 32px -12px rgba(19, 169, 78, 0.65); }
  }

  .kpi--purple {
    background: linear-gradient(135deg, #7c3aed 0%, #470077 100%);
    box-shadow: 0 10px 24px -10px rgba(71, 0, 119, 0.55);

    &:hover { box-shadow: 0 16px 32px -12px rgba(71, 0, 119, 0.7); }
  }

  /* ===== 通用白色面板 ===== */
  .panel-card {
    margin-bottom: 16px;
    border: none;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(31, 45, 61, 0.06);

    &:last-child {
      margin-bottom: 0;
    }

    ::v-deep .el-card__body {
      padding: 18px;
    }
  }

  /* ===== 小指标卡片 ===== */
  .metric-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
  }

  .metric-card {
    --metric-color: #909399;
    position: relative;
    flex: 1 1 calc(100% / 6 - 14px);
    min-width: 158px;
    display: flex;
    align-items: center;
    padding: 14px 16px 14px 18px;
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 10px;
    overflow: hidden;
    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;

    /* 左侧主题色条 */
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 10px;
      bottom: 10px;
      width: 4px;
      border-radius: 0 4px 4px 0;
      background: var(--metric-color);
    }

    &:hover {
      transform: translateY(-3px);
      border-color: transparent;
      box-shadow: 0 12px 24px -12px rgba(31, 45, 61, 0.25);
    }
  }

  .metric-icon {
    flex: none;
    width: 46px;
    height: 46px;
    margin-right: 12px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.04);

    .iconfont {
      font-size: 24px;
      color: var(--metric-color);
    }
  }

  .metric-text {
    min-width: 0;
  }

  .metric-value {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.25;
    color: #1f2d3d;
    white-space: nowrap;
  }

  .metric-label {
    margin-top: 4px;
    font-size: 12px;
    color: #909399;
    white-space: nowrap;
  }

  .metric--teal {
    --metric-color: #0ddbab;
    .metric-icon { background: rgba(13, 219, 171, 0.14); }
  }

  .metric--red {
    --metric-color: #ff5333;
    .metric-icon { background: rgba(255, 83, 51, 0.12); }
  }

  .metric--orange {
    --metric-color: #ff8319;
    .metric-icon { background: rgba(255, 131, 25, 0.12); }
  }

  .metric--green {
    --metric-color: #38ac22;
    .metric-icon { background: rgba(56, 172, 34, 0.12); }
  }

  .metric--purple {
    --metric-color: #af00ff;
    .metric-icon { background: rgba(175, 0, 255, 0.1); }
  }

  .metric--blue {
    --metric-color: #1a4fc4;
    .metric-icon { background: rgba(0, 53, 179, 0.1); }
  }

  .metric--cyan {
    --metric-color: #00b8d9;
    .metric-icon { background: rgba(0, 194, 224, 0.14); }
  }

  .metric--gold {
    --metric-color: #e0a800;
    .metric-icon { background: rgba(255, 204, 0, 0.2); }
  }

  /* ===== 图表区域 ===== */
  .chart-row--half {
    display: flex;
    gap: 8px;
  }

  .chart-row--rank {
    display: flex;
    gap: 8px;
    height: 400px;
  }

  .chart-box {
    flex: 1;
    min-width: 0;
    height: 320px;
  }

  .rank-box {
    height: 100%;
  }

  @keyframes kpiFadeIn {
    from {
      opacity: 0;
      transform: translateY(14px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Works.vue